import { IconButton } from "@src/components/atoms/buttons/icon-button/icon-button";
import React, { RefObject, forwardRef, useRef } from "react";
import { PopoverPositionObjectTypes } from "../blueprint-table-body/blueprint-table-body";
import chatBubbleOvalIcon from "@src/assets/svg/chat-bubble-oval-left.svg";
import styles from "./blueprint-description-popover-button-wrapper.module.scss";
import { calculateRelativeCoordinates } from "./calculate-relative-coordinates";
import { BlueprintsArrayObjectTypes } from "@common/types/blueprint-types";

interface BlueprintDescriptionPopoverButtonWrapperPropTypes {
  blueprint: BlueprintsArrayObjectTypes;
  popoverPositionCallback: (coordinates: PopoverPositionObjectTypes) => void;
  activePopoverCallback: (blueprint: BlueprintsArrayObjectTypes) => void;
  activeBlueprintCallback: (blueprint: BlueprintsArrayObjectTypes) => void;
}

const cssClassName = "blueprint-description-popover-button-wrapper";

export const BlueprintDescriptionPopoverButtonWrapper = forwardRef(
  (
    {
      blueprint,
      popoverPositionCallback,
      activePopoverCallback,
    }: BlueprintDescriptionPopoverButtonWrapperPropTypes,
    ref: RefObject<HTMLDivElement>,
  ) => {
    const blueprintDescriptionButtonRef = useRef<HTMLSpanElement>(null);
    const handleOpenDescriptionPopover = (e, blueprint) => {
      e.preventDefault();
      e.stopPropagation();

      const relativeCoordinates = calculateRelativeCoordinates(
        blueprintDescriptionButtonRef,
        ref,
      );

      popoverPositionCallback(relativeCoordinates);
      activePopoverCallback(blueprint);
    };

    return (
      <span
        className={styles[`${cssClassName}`]}
        ref={blueprintDescriptionButtonRef}
      >
        <IconButton
          fun={(e) => handleOpenDescriptionPopover(e, blueprint)}
          icon={chatBubbleOvalIcon}
        />
      </span>
    );
  },
);
BlueprintDescriptionPopoverButtonWrapper.displayName =
  "BlueprintDescriptionPopoverButtonWrapper";
